<template>
    <div>
        <div v-if="role != 'customer' && role != 'employee'" class="header">
            <button key="button"
                    v-if="!showForm"
                    class="btn btn-primary"
                    :class="{ disabled: showForm }"
                    @click="showForm = true">
                Create new change order
            </button>
            <transition name="fade">
                <div key="key1"
                     v-if="showForm">
                    <new-change-order :project="project" :changeorders="changeorders"></new-change-order>
                </div>
            </transition>
        </div>

        <div v-if="loading" class="card card-default">
            <div class="card-header">
                <span class="loading-text">Loading...</span>
                <span class="loader float-right"></span>
            </div>
        </div>

        <div v-else-if="error" class="card card-default">
            <div class="card-header">
                <div class="">
                    <div><strong>Well, this is embarrassing.</strong> Something went wrong.</div>
                    <div>Please try refreshing the page, or otherwise <a href="mailto:support@sitecommandapp.com?subject=Help!">get in touch</a> and we'll be happy to help!
                    </div>
                </div>
            </div>
        </div>
        <div v-else>
            <caught-up-message v-if="(role == 'customer' || role == 'employee') && !loading && changeorders.length == 0" :object="'change orders'"></caught-up-message>
            <change-order v-else v-for="changeorder in sortedOrders" :role="role" :user="user" :key="changeorder.id" :changeorder="changeorder" :project="project"></change-order>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['role', 'user', 'project'],

        created: function() {
            this.getChangeOrders();
            this.registerEvents();
        },

        mounted: function() {
        },

        data: function() {
            return {
                showForm: false,
                changeOrderCreated: false,
                changeorders: [],
                countPending: 0,
                totalPending: 0,
                total: 0,
                loading: true,
                error: false,
            };
        },

        watch: {
            project: function (newProject, oldProject) {
                this.refresh();
            }
        },

        computed: {
            sortedOrders: function() {
                return _.sortBy(this.changeorders, changeOrder => {
                    return changeOrder.title;
                });
            },
        },

        methods: {
            registerEvents: function() {
                var vm = this;
                Bus.$on('new-change-order-created', function (response) {
                    vm.newChangeOrderCreated(response);
                    return true;
                });
                Bus.$on('new-change-order-canceled', function (response) {
                    vm.showForm = false;
                    return true;
                });
                Bus.$on('change-order-updated', function (response) {
                    vm.changeOrderUpdated(response);
                    return true;
                });
                Bus.$on('change-order-deleted', function(response) {
                    vm.changeOrderDeleted(response.id);
                    return true;
                });
            },

            newChangeOrderCreated: function(changeorder) {
                this.changeOrderCreated = true;
                this.showForm = false;
                this.changeorders.unshift(changeorder);
            },

            changeOrderDeleted: function(deletedChangeOrderId) {
                for (var index in this.changeorders) {
                    var changeorder = this.changeorders[index];
                    if (changeorder.id == deletedChangeOrderId) {
                        // Use Vue.set to get reactivity when changing the contents of an array
                        Vue.delete(this.changeorders, this.changeorders.indexOf(changeorder));
                        break;
                    }
                }

                if (this.changeorders.length == 0) {
                    this.showForm = true;
                }
            },

            changeOrderUpdated: function(updateChangeOrder) {
                for (var index in this.changeorders) {
                    var changeorder = this.changeorders[index];
                    if (changeorder.id == updateChangeOrder.id) {
                        // Use Vue.set to get reactivity when changing the contents of an array
                        Vue.set(this.changeorders, this.changeorders.indexOf(changeorder), updateChangeOrder);
                        break;
                    }
                }
            },

            prettyDate: function (date) {
                return moment.utc(date).local().fromNow();
            },
            /**
             * Get the available member roles.
             */
            getChangeOrders: function() {
                if (!this.project) {
                    return;
                }

                this.changeorders = [];
                axios.get(`/api/changeorders/${this.project.id}`)
                    .then(response => {
                        this.loading = false;
                        this.error = false;
                        this.changeorders = response.data.changeorders;
                        this.total = response.data.total;
                        this.totalPending = response.data.totalPending;
                        this.countPending = response.data.countPending;

                        if (this.changeorders.length == 0) {
                            this.showForm = true;
                        }

                        Bus.$emit('change-order-count-updated', this.changeorders.length);
                    })
                    .catch(error => {
                        this.loading = false;
                        this.error = true;
                    });
            },

            refresh: function() {
                this.loading = true;
                this.getChangeOrders();
            },

        }
    }
</script>
